import { useAppDispatch } from 'legacy/lut/hooks/useAppDispatch'
import { selectLandingAccessState } from 'legacy/lut/selectors/app'
import { LOOKUP_SET_LANDING_ACCESS_STATE } from 'legacy/lut/store/reducer'
import { useCallback, useLayoutEffect } from 'react'
import { useSelector } from 'react-redux'

import { checkLandingAccess } from 'partner360/services/landing/checkLandingAccess'

export const useLandingAccess = () => {
  const dispatch = useAppDispatch()
  const { isAllowed, isFetched, type, isLoading, landingPage } =
    useSelector(selectLandingAccessState)

  const fetchLandingAccess = useCallback(async () => {
    dispatch({
      type: LOOKUP_SET_LANDING_ACCESS_STATE,
      payload: {
        isAllowed: false,
        isFetched: false,
        isWelcomeFlowShown: false,
        isWelcomeFlowEligible: false,
        isLoading: true,
        type: null,
        landingPage: null,
      },
    })

    const { isAllowed, type, isWelcomeFlowEligible, isWelcomeFlowShown, landingPage } =
      await checkLandingAccess()

    dispatch({
      type: LOOKUP_SET_LANDING_ACCESS_STATE,
      payload: {
        isAllowed,
        isWelcomeFlowEligible,
        isWelcomeFlowShown,
        isFetched: true,
        isLoading: false,
        type,
        landingPage,
      },
    })
  }, [dispatch])

  useLayoutEffect(() => {
    if (!isFetched) {
      fetchLandingAccess()
    }
  }, [isFetched, fetchLandingAccess])

  return {
    isPBMLandingAllowed: isAllowed && type === 'PBM',
    isManagerLandingAllowed: isAllowed && type === 'Manager',
    isLoading,
    isFetched,
    landingPage,
  }
}
